import { createAction } from '@reduxjs/toolkit'

export const setToken = createAction('SET_TOKEN');
export const logout = createAction('LOGOUT');